/**
 * Created by lvardarova on 29/04/16.
 */
import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

export function Delete(props) {
    return (
        <SvgIcon {...props}>
            <path d="M1.655,3.396v8.618h8.689V3.396H1.655z M3.953,10.839H2.897V4.572h1.056V10.839z M6.528,10.839H5.472 V4.572h1.057V10.839z M9.104,10.839H8.047V4.572h1.056V10.839z M10.345,1.549v1.065H1.655V1.549C2.627,1.245,4.208,1.047,6,1.047 S9.374,1.245,10.345,1.549z M10.758,3.396H12v1.175h-1.242V3.396z M0,3.396h1.241v1.175H0V3.396z" />
        </SvgIcon>
    );
}

Delete.defaultProps = {
    viewBox: '0 0 12 16'
};


export default Delete;
